export function resolvePermissionEnforcement(value?: string) {
  return value?.trim().toLowerCase() === 'true';
}

export const permissionConfig = {
  enabled: resolvePermissionEnforcement(import.meta.env?.VITE_ENABLE_PERMISSIONS),
} as const;
